<template>
<div :class="class_name" @click="onChange">
    <div class="button"></div>
</div>
</template>

<script>
export default {
    name: "toggle-input",

    props: ["disabled", "toggled"],

    computed: {
        class_name: function () {
            return [
                "toggle-input",
                {
                    disabled: this.disabled,
                    toggled: this.toggled
                }
            ]
        }
    },

    methods: {
        onChange: function () {
            if (!this.disabled) {
                this.$emit("change", !this.toggled)
            }
        }
    }
}
</script>

<style>
.toggle-input {
    background: #efefef;
    border: 1px solid #e7e7e7;
    border-radius: 40px;
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    padding: 4px;
    width: 42px;
}

.toggle-input.disabled {
    cursor: default;
    opacity: 0.5;
}

.toggle-input.toggled {
    justify-content: flex-end;
}

.toggle-input.toggled .button {
    background: #4dcb62;
}

.toggle-input .button {
    background: #bbb;
    border-radius: 100%;
    cursor: inherit;
    height: 14px;
    line-height: 1;
    padding: 0;
    transition: all 0.15s ease;
    width: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/ToggleInput.vue